import {Component, OnInit} from '@angular/core';
import {ListComponent, ItemComponent} from '../commons/list.component';
import {AppComponent} from 'app/app.component';
import {ConfirmationService, MessageService} from 'primeng/api';
import {PartnersService} from './partners.service';
import {Router, ActivatedRoute} from '@angular/router';
import {PartnerGroup} from 'models/beans';
import {AppBreadcrumbService} from '../../app.breadcrumb.service';

@Component({
    selector: 'afm-partners',
    templateUrl: '../commons/items.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class PartnersComponent implements OnInit {

    title : string = 'Partners Management'
    
    constructor() {}

    ngOnInit() {
    }
}

@Component({
    templateUrl: '../commons/list.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class PartnerListComponent extends ListComponent implements OnInit {

    constructor(private cs: ConfirmationService, private ms: MessageService,private s: PartnersService, private a: AppComponent, private bs: AppBreadcrumbService) {
        super(cs,ms,s,a,bs);
    }

    ngOnInit() {
        super.ngOnInit()
        this.title = 'List of Partners';
        
    }
    getPath(){
        return 'partner';
    }

    getCols(){
        return [
            { field: 'id', header: 'ID' ,placeHolder:'' ,width : '60px' },
            { field: 'code', header: 'Code',placeHolder:'' ,width : '150px',filtered : true,type : 'text' },
            { field: 'name', header: 'Name',placeHolder:'',filtered : true,type : 'text' },
            { field: 'niu', header: 'Niu',placeHolder:'',filtered : true,type : 'text' },
            { field: 'count', header: 'Users count' ,placeHolder:'',filtered : true,type : 'numeric'}
        ];
    }
}
@Component({
    templateUrl: './partner.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class PartnerComponent extends ItemComponent implements OnInit {
    
    partnerGroups : PartnerGroup[] = [];

    constructor(private ms: MessageService, private s: PartnersService,
        private a: AppComponent, private rt: Router, private r: ActivatedRoute, private bs: AppBreadcrumbService) {
        super(ms,s,a,rt,r,bs);
    }

    ngOnInit() {
        super.ngOnInit()
        this.s.getPartnerGroups().then(data => this.partnerGroups = data);
    }
    
    prepareCreate(){
        this.item.partnerGroupIds = [];
    }
    
    getPath(){
        return 'partners';
    }
    getSuccessMessage(){
        return 'Partner save with success';
    }
    getSelectedGroups(items : any[]) : string[]{
        return items.map(item =>  item.name);
    }
}

